import { _TEST1234 } from "../../config/ApiConfig";

export const LoginHeaderLogo = () => {
    switch (_TEST1234.SYSTEM_GROUP_ORI) {
        case "tancis":
            return (
                <img
                    className="px-4 py-2 rounded-3xl bg-white"
                    src={process.env.PUBLIC_URL + "/imgs/tancis_logo.svg"}
                    alt="tancis logo"
                    title="tancis logo"
                    width={106}
                    height={22}
                />
            );
        case "tanesw":
            return (
                <img
                    className="px-4 py-2"
                    src={process.env.PUBLIC_URL + "/imgs/tanesw_logo.svg"}
                    alt="tanesw logo"
                    title="tanesw logo"
                    width={122}
                    height={22}
                />
            );
        case "tanoga":
            return (
                <img
                    className="px-4 py-2 rounded-3xl"
                    src={process.env.PUBLIC_URL + "/imgs/tanoga_logo.svg"}
                    alt="tanoga logo"
                    title="tanoga logo"
                    width={121}
                    height={22}
                />
            );
        default:
            return null;
    }
};
